<template>
    <div>
        <sidebar-event-contact :event-id="event.id" :event="event" v-bind="contact">
            <v-list-item-action style="width: 150px" class="ml-6">
                <v-btn block v-if="$can('create', 'EventContact') && contact.contactTypeId !== RESOLVER_CONTACT_TYPE_ID" color="warning" @click="showConfirmModal">Kontakt na VZ</v-btn>
                <v-btn block v-if="$can('create', 'EventContact') && contact.contactTypeId === RESOLVER_CONTACT_TYPE_ID" color="error" @click="unsetResolver">Odebrat z VZ</v-btn>
            </v-list-item-action>
            <v-dialog v-model="isModal" max-width="400">
                <v-card>
                    <v-toolbar dark dense>
                        <v-toolbar-title>Kontakt na Velitele zásahu (VZ)</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="close">
                        <v-icon>cancel</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="pt-8">
                        <v-text-field v-model="form.name" outlined label="Jméno velitele zásahu" hide-details></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn @click="close" text>Zpět</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="warning" @click="setAsResolver">Nastavit</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </sidebar-event-contact>
    </div>
</template>

<script>

import { RESOLVER_CONTACT_TYPE_ID } from "@/store/modules/event/contacts";
import SidebarEventContact from "@/components/panel/sidebar/event/Contact.vue";

export default {
    name: 'set-role-form-item',
    components: {SidebarEventContact},
    data() {
        return {
            isModal: false,
            form: {
                name: null
            },
            RESOLVER_CONTACT_TYPE_ID,
        }
    },
    props: {
        contact: [Object, {}],
        event: [Object, {}],
    },
    methods: {
        showConfirmModal() {
            this.form.name = this.contact.name;
            this.isModal = true;
        },
        unsetResolver() {
            this.$emit('onUnsetResolver', this.contact);
        },
        setAsResolver() {
            this.$emit('onConfirm', this.contact, this.form);
        },
        close() {
            this.isModal = false;
            this.$emit('onClose');
        },
    }
}
</script>
